<template>
  <div class="home">
    <main-navigation animation />
    <div style="min-height:400px">
      <router-view />
    </div>
    <footer-navigation animation />
    <location-dialog :suggested="suggested" v-model="showLocationDialog" />
  </div>
</template>

<script>
import RegionRouter from '@/mixins/RegionRouter.js'

export default {
  mixins: [RegionRouter]
}
</script>
